import { render } from "./Arena.vue?vue&type=template&id=7ddc4726"
import script from "./Arena.vue?vue&type=script&lang=js"
export * from "./Arena.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__